// extracted by mini-css-extract-plugin
export default {"headerLogo":"styles_headerLogo__nq4G4","navbar":"styles_navbar__JcMGX","headerTitle":"styles_headerTitle__6FyGW","links":"styles_links__M-0bg","book":"styles_book__8Lcrn"};